<template>
  <div>
    <h5>What would you like to do?</h5>
    <div class="list-group">
        <router-link class="list-group-item list-group-item-action" to="/makeaclaim">Make a claim</router-link>
        <router-link class="list-group-item list-group-item-action" to="/myclaims/inprogress">View in-progress claim forms</router-link>
        <router-link class="list-group-item list-group-item-action" to="/myclaims">View submitted claims</router-link>
        <router-link class="list-group-item list-group-item-action" to="/myclaims/uploadinvoice">Upload repair invoice</router-link>
        <router-link class="list-group-item list-group-item-action" to="/myclaims/repairoptions">Select / cancel a repair option</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'taskList'
}
</script>
